module.exports = __webpack_public_path__ + "static/feature7-5e64fefca1a68cc7211dd76320776dbd.png";